import React, { useState } from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { useTranslations } from '@libs/translations';
import { Button } from 'planoplan-ui-kit/core/button';
import { Colors } from 'planoplan-ui-kit/core/colors';
import { deviceDetected } from 'planoplan-ui-kit/core/device-detected';
import { useMediaQuery } from 'planoplan-ui-kit/core/hooks/useMediaQuery';
import { SectionNumber } from '@components/Section-Number';
import { EmailPopup } from '@components/Email-Popup';
import { Points } from '@styles';
import { DownloadButton } from './organism/download-button';
import { AuthorsLightbox } from './organism/lightbox';
import { Column } from './organism/column';

const EyeSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M1.3335 7.99967C1.3335 7.99967 3.75774 3.33301 8.00016 3.33301C12.2426 3.33301 14.6668 7.99967 14.6668 7.99967C14.6668 7.99967 12.2426 12.6663 8.00016 12.6663C3.75774 12.6663 1.3335 7.99967 1.3335 7.99967Z"
      stroke="#292929"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10Z"
      stroke="#292929"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Authors = () => {
  const translations = useTranslations();
  const { locale } = useSelector((state) => state.settings);
  const isTabletPortrait = useMediaQuery(Points.tablet_portrait, { useSSR: true });
  const isDesktopWide = useMediaQuery(Points.laptop_wide, { useSSR: true });
  const isMobileDevice = deviceDetected.isMobile;

  const [isPopUpShow, setIsPopUpShow] = useState(false);
  const [showList, setShowList] = useState([1]);
  const [lightboxIndex, setLightboxIndex] = useState(null);

  const onSubmitClickHolder = () => {
    setIsPopUpShow(false);
  };

  const showMoreClickHolder = () => {
    const nextIndex = showList.slice().length + 1;

    setShowList([...showList, nextIndex]);
  };

  const closeLightbox = () => {
    setLightboxIndex(null);
  };

  const showPrevImage = () =>
    setLightboxIndex((prevIndex) => (prevIndex - 1 + allAuthorsContent.length) % allAuthorsContent.length);

  const showNextImage = () => setLightboxIndex((prevIndex) => (prevIndex + 1) % allAuthorsContent.length);

  const Authors = {
    fahretdinova: {
      author_ru: `Елена Фахретдинова`,
      author_en: `Elena Fakhretdinova`,
      ava: [`fahretdinova-1x.png`, `fahretdinova-2x.png`],
      alt: `site.home.authors.elena-fakhretdinova`,
    },
    krapan: {
      author_ru: `Ирина Крапан`,
      author_en: `Irina Krapan`,
      ava: [`krapan-1x.png`, `krapan-2x.png`],
      alt: `site.home.authors.irina-krapan`,
    },
    koryabkina: {
      author_ru: `Анастасия Корябкина`,
      author_en: `Anastasiya Koryabkina`,
      ava: [`koryabkina-1x.png`, `koryabkina-2x.png`],
      alt: `site.home.authors.anastasiya-koryabkina`,
    },
    kravchenko: {
      author_ru: `Елена Кравченко`,
      author_en: `Elena Kravchenko`,
      ava: [`kravchenko-1x.png`, `kravchenko-1x.png`],
      alt: `site.home.authors.elena-kravchenko`,
    },
    mykolyuk: {
      author_ru: `Дмитрий Миколюк`,
      author_en: `Dmitry Mykolyuk`,
      ava: [`mikolyk-1x.png`, `mikolyk-2x.png`],
      alt: `site.home.authors.dmitry-mykolyuk`,
    },
    panova: {
      author_ru: `Светлана Панова`,
      author_en: `Svetlana Panova`,
      ava: [`panova-1x.png`, `panova-2x.png`],
      alt: `site.home.authors.svetlana-panova`,
    },
  };

  const columnOneContent = [
    {
      srcset: [`01_one-1x.jpg`, `01_one-1x.webp`, `01_one-2x.jpg`, `01_one-2x.webp`],
      author: Authors.fahretdinova,
      caption_ru: `Проект спальни`,
      caption_en: `Bedroom Design`,
    },
    {
      srcset: [`02_one-1x.jpg`, `02_one-1x.webp`, `02_one-2x.jpg`, `02_one-2x.webp`],
      author: Authors.krapan,
      caption_ru: `Проект базы отдыха`,
      caption_en: `Recreation Center Project`,
    },
    {
      srcset: [`03_one-1x.jpg`, `03_one-1x.webp`, `03_one-2x.jpg`, `03_one-2x.webp`],
      author: Authors.koryabkina,
      caption_ru: `Проект виллы с бассейном`,
      caption_en: `Villa design with a pool`,
    },
    {
      srcset: [`04_one-1x.jpg`, `04_one-1x.webp`, `04_one-2x.jpg`, `04_one-2x.webp`],
      author: Authors.fahretdinova,
      caption_ru: `Проект гостиной`,
      caption_en: `Living room design`,
    },
    {
      srcset: [`05_one-1x.jpg`, `05_one-1x.webp`, `05_one-2x.jpg`, `05_one-2x.webp`],
      author: Authors.kravchenko,
      caption_ru: `проект загородного дома`,
      caption_en: `country house design`,
    },
  ];

  const columnTwoContent = [
    {
      srcset: [`01_two-1x.jpg`, `01_two-1x.webp`, `01_two-2x.jpg`, `01_two-2x.webp`],
      author: Authors.mykolyuk,
      caption_ru: `Проект спальни`,
      caption_en: `Bedroom Design`,
    },
    {
      srcset: [`02_two-1x.jpg`, `02_two-1x.webp`, `02_two-2x.jpg`, `02_two-2x.webp`],
      author: Authors.koryabkina,
      caption_ru: `Проект ресторана`,
      caption_en: `Restaurant design`,
    },
    {
      srcset: [`03_two-1x.jpg`, `03_two-1x.webp`, `03_two-2x.jpg`, `03_two-2x.webp`],
      author: Authors.krapan,
      caption_ru: `Проект глэмпинга`,
      caption_en: `Glamping project`,
    },
    {
      srcset: [`04_two-1x.jpg`, `04_two-1x.webp`, `04_two-2x.jpg`, `04_two-2x.webp`],
      author: Authors.koryabkina,
      caption_ru: `Проект ресторана`,
      caption_en: `Restaurant design`,
    },
    {
      srcset: [`05_two-1x.jpg`, `05_two-1x.webp`, `05_two-2x.jpg`, `05_two-2x.webp`],
      author: Authors.fahretdinova,
      caption_ru: `Проект ванной`,
      caption_en: `Bathroom design`,
    },
  ];

  const columnThreeContent = [
    {
      srcset: [`01_three-1x.jpg`, `01_three-1x.webp`, `01_three-2x.jpg`, `01_three-2x.webp`],
      author: Authors.mykolyuk,
      caption_ru: `Проект гостиной`,
      caption_en: `Living room design`,
    },
    {
      srcset: [`02_three-1x.jpg`, `02_three-1x.webp`, `02_three-2x.jpg`, `02_three-2x.webp`],
      author: Authors.fahretdinova,
      caption_ru: `Проект загородного дома`,
      caption_en: `Country house project`,
    },
    {
      srcset: [`03_three-1x.jpg`, `03_three-1x.webp`, `03_three-2x.jpg`, `03_three-2x.webp`],
      author: Authors.panova,
      caption_ru: `Проект спальни`,
      caption_en: `Bedroom design`,
    },
    {
      srcset: [`04_three-1x.jpg`, `04_three-1x.webp`, `04_three-2x.jpg`, `04_three-2x.webp`],
      author: Authors.fahretdinova,
      caption_ru: `Проект спальни`,
      caption_en: `Bedroom design`,
    },
    {
      srcset: [`05_three-1x.jpg`, `05_three-1x.webp`, `05_three-2x.jpg`, `05_three-2x.webp`],
      author: Authors.koryabkina,
      caption_ru: `Проект частного дома`,
      caption_en: `House prodject`,
    },
  ];

  const allAuthorsContent = [...columnOneContent, ...columnTwoContent, ...columnThreeContent];
  const columnTwoOffset = columnOneContent.length;
  const columnThreeOffset = columnOneContent.length + columnTwoContent.length;

  const withAlt = (items) =>
    items.map((item) => ({
      ...item,
      alt: `${locale === 'ru' ? item.caption_ru : item.caption_en} — ${
        locale === 'ru' ? item.author.author_ru : item.author.author_en
      }`,
    }));

  return (
    <View id="authors">
      <Content>
        <WrapperTop>
          <SectionNumber number={''} text={translations.t('site.home.authors.name')} textColor={Colors.white} />
          <Title>{translations.t('site.home.authors.title')}</Title>
          <Description>{translations.t('site.home.authors.description')}</Description>
        </WrapperTop>
        <WrapperImages>
          <Column items={withAlt(columnOneContent)} onItemClick={(index) => setLightboxIndex(index)} />
          <Column
            items={withAlt(columnTwoContent)}
            isShow={showList.findIndex((i) => i === 2) !== -1}
            offset={columnTwoOffset}
            onItemClick={(index) => setLightboxIndex(index)}
          />
          <Column
            items={withAlt(columnThreeContent)}
            isShow={showList.findIndex((i) => i === 3) !== -1}
            offset={columnThreeOffset}
            onItemClick={(index) => setLightboxIndex(index)}
          />
        </WrapperImages>
        <WrapperBottom>
          {!isTabletPortrait && showList.length < 3 && (
            <Button
              className="neutral-btn"
              theme="neutral_secondary"
              onClick={showMoreClickHolder}
              widthText={true}
              size={isDesktopWide ? 'L' : isTabletPortrait ? 'M' : 'S'}>
              <EyeSvg /> {translations.t('site.home.authors.btnLink-watchMore')}
            </Button>
          )}
          <ButtonWrapper>
            <SmallTitle>{translations.t('site.home.authors.cta')}</SmallTitle>
            {isMobileDevice ? (
              <Wrapper>
                {locale === 'ru' && (
                  <Button
                    theme="primary"
                    data-gtm="button_click"
                    size={isDesktopWide ? 'L' : isTabletPortrait ? 'M' : 'S'}
                    href={`/${locale}/webinars`}>
                    {translations.t('site.home.firstscreen.mobileBtnWebinar')}
                  </Button>
                )}
                <Button
                  theme={locale === 'ru' ? 'secondary' : 'primary'}
                  data-gtm="button_click"
                  size={isDesktopWide ? 'L' : isTabletPortrait ? 'M' : 'S'}
                  href={`/${locale}/download`}>
                  {translations.t('site.home.firstscreen.mobileBtnDownload')}
                </Button>
              </Wrapper>
            ) : (
              <DownloadButton />
            )}
            <Caption>{translations.t('site.home.authors.caption')}</Caption>
          </ButtonWrapper>
        </WrapperBottom>
        <EmailPopup
          isOpen={isPopUpShow}
          title={translations.t('site.home.popup.title')}
          buttonText={translations.t('site.home.popup.btnText')}
          onClose={() => setIsPopUpShow(false)}
          onSubmit={onSubmitClickHolder}
        />
      </Content>
      {lightboxIndex !== null && isTabletPortrait && (
        <AuthorsLightbox
          item={allAuthorsContent[lightboxIndex]}
          locale={locale}
          onClose={closeLightbox}
          onPrev={showPrevImage}
          onNext={showNextImage}
        />
      )}
    </View>
  );
};

const View = styled.section`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 30px 16px;
  background-color: ${Colors.main_black};
  color: ${Colors.white};

  @media ${Points.tablet_landscape} {
    padding: 40px 0;
  }

  @media ${Points.laptop_wide} {
    padding: 84px 80px 75px;
  }

  @media ${Points.fullhd} {
    padding: 90px 160px 80px;
  }
`;

const Content = styled.div`
  @media ${Points.tablet_landscape} {
    width: 100%;
    max-width: 1024px;
    padding: 0 28px;
  }

  @media ${Points.laptop_wide} {
    width: 100%;
    max-width: 1600px;
    padding: 0;
  }
`;

const WrapperTop = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 430px;
  margin: 0 auto 30px;

  @media ${Points.tablet_landscape} {
    width: 430px;
    max-width: auto;
    text-align: center;
    margin: 0 auto 40px;
  }

  @media ${Points.laptop_wide} {
    width: 715px;
    max-width: 715px;
  }

  @media ${Points.fullhd} {
    margin-bottom: 20px;
  }
`;

const WrapperImages = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: no-wrap;
  gap: 20px;

  img {
    cursor: pointer;
  }

  @media ${Points.tablet_portrait} {
    flex-direction: row;
    gap: 13px;
  }

  @media ${Points.tablet_landscape} {
    flex-direction: row;
    gap: 13px;
    max-width: 1180px;
  }

  @media ${Points.laptop_wide} {
    gap: 19px;
    max-width: 1286px;
    margin: 0 auto;
  }

  @media ${Points.fullhd} {
    gap: 30px;
    max-width: 1560px;
  }
`;

const WrapperBottom = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 40px;
  margin-top: 30px;

  .neutral-btn svg {
    margin-right: 8px;
  }

  .neutral-btn {
    padding: 0 28.5px;
  }

  @media ${Points.tablet_landscape} {
    margin-top: 40px;
  }

  @media ${Points.laptop_wide} {
    margin-top: 65px;
  }
`;

const ButtonWrapper = styled.div`
  width: 100%;

  @media ${Points.tablet_portrait} {
    min-width: 280px;
    width: max-content;
  }

  @media ${Points.tablet_landscape} {
    margin: 0 auto;
  }

  @media ${Points.laptop_wide} {
    width: max-content;
  }
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  & a {
    border: none;
  }

  @media ${Points.tablet_portrait} {
    width: 280px;
  }
`;

const Title = styled.h2`
  width: 100%;
  margin-top: -5px;
  margin-bottom: 15px;
  text-align: ${(p) => p.isCenter && 'center'};
  font-weight: 400;
  font-size: 26px;
  line-height: 1;
  letter-spacing: 0%;
  font-variant-numeric-fraction: stacked-fractions;

  @media ${Points.tablet_portrait} {
    text-align: center;
  }

  @media ${Points.tablet_landscape} {
    font-size: 34px;
  }

  @media ${Points.laptop_wide} {
    font-size: 54px;
  }
`;

const SmallTitle = styled.h3`
  width: 100%;
  margin-bottom: 20px;
  text-align: center;
  font-weight: 400;
  font-size: 26px;
  line-height: 1;
  letter-spacing: 0%;

  @media ${Points.tablet_landscape} {
    font-size: 34px;
  }

  @media ${Points.laptop_wide} {
    font-size: 36px;
  }
`;

const Description = styled.p`
  width: 100%;
  font-weight: 400;
  font-size: 12px;
  line-height: 1.1;
  letter-spacing: 1%;

  @media ${Points.tablet_portrait} {
    text-align: center;
  }

  @media ${Points.laptop_wide} {
    width: 470px;
    font-size: 14px;
  }
`;

const Caption = styled.p`
  margin-top: 15px;
  text-align: center;
  font-weight: 400;
  font-size: 12px;
  line-height: 1.1;
  letter-spacing: 1%;
  color: ${Colors.white};

  @media ${Points.tablet_landscape} {
    font-size: 14px;
  }
`;
